import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useReducer, useState } from 'react';
import { toast } from 'react-toastify';
import passwordVerification from '../components/passwordVerification.js';
import PaymentForm from '../components/payments/payment-form.js';
import { useEffect } from 'react';
import SubscriptionCard from '../components/payments/subscription-cards.js';

const initialUser = {
    firstName: "",
    lastName: "",
    email: "",
    role: "Host/Guest",
    userName: "",
    password: "",
    confirmPassword: "",
    podcastName: "",
    hosted: false
};

const userReducer = (state, action) => {
  var newState = {...state};
  newState[action.key] = action.value;
  return newState;
};

function Join() {
    const navigate = useNavigate();
    const [user, dispatch] = useReducer(userReducer, localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : initialUser);
    const [loading, setLoading] = useState(false);
    const [section, setSection] = useState(0);
    const [firstRender, setFirstRender] = useState(true);
    const [products, setProducts] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const validate = () => {
        var errors = [];
        if (user.firstName.trim() == '')
            errors.push('A first name is required.');
        if (user.lastName.trim() == '')
            errors.push('A last name is required.');
        /*if (user.userName.trim().length < 4)
            errors.push('A username of at least 4 characters is required.');*/
        if (!user.email.match(/^[\w\.-]+@[\w\.-]+\.\w+$/))
            errors.push('A valid email is required.');
        var passError = passwordVerification(user.password);
        if (passError)
            errors.push(passError);
        if (user.password.trim() != user.confirmPassword.trim())
            errors.push('You password and password confirmation must match.');
        return errors;
    }
    useEffect(() => {
        if (!firstRender)
            return;
        setFirstRender(false);
        axios.get(process.env.REACT_APP_API_URL + 'products').then((r) => {
                if (r?.data) {
                    setProducts(r.data);
                }
            });
        localStorage.removeItem('user');
        const params = new URLSearchParams(window.location.search);
        const paymentFailure = params.get("payment-failure");
        if (paymentFailure) {
            toast.error('There was an error processing your payment.');
        }
    }, [firstRender])
    const join = () => {
        if (loading)
            return;
        var err = validate();
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'signup', {
                firstName: user.firstName.trim(),
                lastName: user.lastName.trim(),
                email: user.email.trim(),
                role: user.role,
                username: user.userName.trim(),
                password: user.password.trim(),
                podcastName: user.podcastName
            }).then((r) => {
                    setLoading(false);
                    if (r?.data?.token) {
                        localStorage.setItem('jwt', r.data.token);
                        setTimeout(() => navigate(r.data.to), 1750);
                        toast.success('Joined successfully.');
                    }
                }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    const continueJoin = () => {
        var err = validate();
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'user/check', {
                username: user.email.trim()
            }).then((r) => {
                    setLoading(false);
                    if (r?.data?.status == 'Success') {
                        setSection(1);
                        localStorage.setItem('user', JSON.stringify(user));
                    }
                }).catch(err => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    return (
        <div className="container-center">
            <div className="container mw-800 w-100 p-10">
                {section == 0 && (
                    <>
                        <h1 className="mb-20"><b>Join</b></h1>
                        <div className="form">
                            <div className="w-50 xs-w-100">
                                <label>First Name</label>
                                <input type="text" value={user.firstName} onChange={(e) => { dispatch({ key: 'firstName', value: e.target.value}) }} />
                            </div>
                            <div className="w-50 xs-w-100">
                                <label>Last Name</label>
                                <input type="text" value={user.lastName} onChange={(e) => { dispatch({ key: 'lastName', value: e.target.value}) }} />
                            </div>
                            {/*<div className="w-50 xs-w-100">
                                <label>Username</label>
                                <input type="text" value={user.userName} onChange={(e) => { dispatch({ key: 'userName', value: e.target.value}) }} />
                            </div>*/}
                            <div className="w-50 xs-w-100">
                                <label>Email</label>
                                <input type="email" value={user.email} onChange={(e) => { dispatch({ key: 'email', value: e.target.value}) }} />
                            </div>
                            <div className="w-100">
                                <label>Type</label>
                                <div className="flex f-row gap-20 w-100">
                                    <div className="flex f-row gap-5 a-center" style={{flexGrow: 0}}>
                                        <input style={{margin: 0}} type="radio" checked={user.role == "Host/Guest"} onChange={() => dispatch({ key: 'role', value: "Host/Guest"})} />
                                        <label style={{marginBottom: 0}}>Host/Guest</label>
                                    </div>
                                    <div className="flex f-row gap-5 a-center" style={{flexGrow: 0}}>
                                        <input style={{margin: 0}} type="radio" checked={user.role == "Podcast"} onChange={() => dispatch({ key: 'role', value: "Podcast"})} />
                                        <label style={{marginBottom: 0}}>Podcast</label>
                                    </div>
                                </div>
                            </div>
                            {user.role == 'Podcast' && false && (
                                <div className="w-100">
                                    <div className="flex f-row w-100">
                                        <label>Podcast Name</label>
                                    
                                        <div className="ml-auto f-row gap-10" style={{flexGrow: 0}}>
                                            <label htmlFor="hosted-podcast">Hosted</label>
                                            <label className="switch mb-0">
                                                <input type="checkbox" id="hosted-podcast" onChange={e => {
                                                    dispatch({ key: 'hosted', value: e.target.value});
                                                }} checked={user.hosted} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <input type="text" value={user.podcastName} onChange={(e) => { dispatch({ key: 'podcastName', value: e.target.value}) }} />
                                </div>
                            )}
                            <div className="w-50 xs-w-100">
                                <label>Password</label>
                                <input type="password" autoComplete='new-password' value={user.password} onChange={(e) => { dispatch({ key: 'password', value: e.target.value}) }} />
                            </div>
                            <div className="w-50 xs-w-100">
                                <label>Confirm Password</label>
                                <input type="password" autoComplete='new-password' value={user.confirmPassword} onChange={(e) => { dispatch({ key: 'confirmPassword', value: e.target.value}) }} />
                            </div>
                            <div className="w-100 f-row f-end gap-10">
                                <button className="btn" onClick={continueJoin}>
                                    {loading ? (
                                        <div className="loading f-row">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    ) : <>Continue</>
                                    }
                                </button>
                                <Link className="btn btn-orange" to="/login">
                                    Login
                                </Link>
                            </div>
                        </div>
                    </>
                )}
                {section == 1 && (
                    <>
                        <div className="flex f-row a-center mb-40">
                            <h1><b>Select Payment Plan</b></h1>
                        </div>
                        <div className="form">
                            <div className="w-100 f-row f-center gap-10">
                                {products.find(p => p.name == user.role + ' Profile').prices.map((p, i) => {
                                    let bestDeal = false;
                                    let save = 0;
                                    let title = 'Monthly'
                                    if (p.interval == 'year') {
                                        title = 'Yearly';
                                        let monthly = products.find(p => p.name == user.role + ' Profile').prices.find(p => p.interval == 'month');
                                        save = monthly.amount * 12 - p.amount;
                                        bestDeal = true;
                                    }
                                    return (
                                        <SubscriptionCard key={i}
                                                        price={p}
                                                        bestDeal={bestDeal}
                                                        save={save}
                                                        title={title}
                                                        isSelected={selectedPrice?.id == p.id}
                                                        onClick={p => setSelectedPrice(p)} />
                                    );
                                })}
                            </div>
                            <div className="w-100 f-row f-end gap-10">
                                <button className="btn" onClick={() => {
                                    if (!selectedPrice)
                                        return;
                                    setSection(2);
                                }} disabled={!selectedPrice}>
                                    Continue
                                </button>
                                <button className="btn btn-orange" onClick={() => {
                                    setSelectedPrice(null);
                                    setSection(0);
                                }}>
                                    Back
                                </button>
                            </div>
                        </div>
                    </>
                )}
                {section == 2 && (
                    <>
                        <div className="flex f-row a-center mb-20">
                            <h1 className="mr-20"><b>Make Your Payment</b></h1>
                            <button className="btn btn-orange ml-auto" onClick={() => setSection(1)}>
                                Back
                            </button>
                        </div>
                        <div className="form">
                            <div className="w-100 xs-w-100">
                                <PaymentForm user={user}
                                            redirect={process.env.REACT_APP_URL + 'payment-success'}
                                            item={selectedPrice}
                                            product={user.role + ' Profile'} />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Join;